import { resolveErrorMessage } from 'modules/errors';
import { fetchNDA, postNDA, deleteNDA } from './api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// TODO: is this even used anymore?

export const loadNDA = createAsyncThunk(
  'ndas/load',
  async auditionId => await fetchNDA(auditionId),
);
export const createNDA = createAsyncThunk(
  'ndas/post',
  async ({ auditionId, url }) => await postNDA(auditionId, url),
);
export const removeNDA = createAsyncThunk(
  'ndas/delete',
  async auditionId => await deleteNDA(auditionId),
);

const ndasSlice = createSlice({
  name: 'ndas',
  initialState: {
    nda: null,
    loading: false,
    loadError: false,
    createError: false,
    removeError: false,
  },
  extraReducers: builder => {
    builder
      .addCase(loadNDA.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(loadNDA.fulfilled, (state, action) => {
        state.nda = action.payload.data;
        state.loading = false;
      })
      .addCase(loadNDA.rejected, (state, action) => {
        state.loadError = resolveErrorMessage(action.error);
        state.loading = false;
      })
      .addCase(createNDA.fulfilled, (state, action) => {
        state.nda = action.payload.data;
      })
      .addCase(createNDA.rejected, (state, action) => {
        state.createError = resolveErrorMessage(action.error);
      })
      .addCase(removeNDA.fulfilled, (state, _) => {
        state.nda = null;
      })
      .addCase(removeNDA.rejected, (state, action) => {
        state.createError = resolveErrorMessage(action.error);
      });
  },
  selectors: {
    getAuditionNDA: state => state.nda,
  },
});

export const reducer = ndasSlice.reducer;
export const { getAuditionNDA } = ndasSlice.selectors;
